import { Button } from "@archery-inc/design-system";

export default function App() {
  const handleRedirect = () => {
    window.location.href = "https://app.mojo.video";
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="space-y-4">
          <div>🚀</div>
          <h1 className="text-3xl">We&apos;ve moved to Mojo!</h1>
          <p className="text-lg">
            Great news! Reveals has found a new home at Mojo. Don&apos;t worry -
            all your credits and content are safely waiting for you there.
          </p>
        </div>

        <div className="flex justify-center">
          <Button onPress={handleRedirect}>Take me to Mojo!</Button>
        </div>
      </div>
    </div>
  );
}
